import { MasterProductModel } from "../../../models/masterProduct";
import { useEffect, useState } from "react";
import { OrderShipmentModel } from "../../../models/orderShipment";
import { ProductBadgeModel } from "../../../models/productBadge";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import axios from "../../../lib/axios";
import {
  PRODUCT_CREATE,
  // PRODUCT_MASTER_FIND_MANY,
  PRODUCT_UPDATE,
} from "../../../lib/endpoints/product";
import { IMAGE_PRODUCTS_ROOT_URL } from "../../../constants/imageUrl";
import { objectToQueryString } from "../../../utils/objectToQueryString";
import { ProductMerchantModel } from "../../../models/productMerchant";
interface Props {
  selectedData: ProductMerchantModel;
  onClose: VoidFunction;
  onRefetchData: any;
  merchant: {
    id: string;
  };
  isFormUpdateData: boolean;
}

const useProductMerchantFormController = ({
  selectedData,
  onClose,
  onRefetchData,
  merchant,
  isFormUpdateData,
}: Props) => {
  // variables

  const { i18n } = useTranslation("global");

  const [imageMainFile, setImageMainFile] = useState<any>(null);
  const [imageMainToShow, setImageMainToShow] = useState<any>(null);

  const [imageSecondaryFile, setImageSecondaryFile] = useState<any>([]);
  const [imageSecondaryToShow, setImageSecondaryToShow] = useState<any>([]);

  const [errorMessage, setErrorMessage] = useState<string>("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingGetProductByItemCode, setLoadingGetProductByItemCode] =
    useState<boolean>(false);
  const [masterProductData, setMasterProductData] = useState<
    MasterProductModel[]
  >([]);
  const [
    errorGetProductByItemCodeMessage,
    setErrorGetProductByItemCodeMessage,
  ] = useState<string>(null!);
  const [selectedPackType, setSelectedPackType] = useState<string>(null!);
  const [dataPackType, setDataPackType] = useState<string[]>([]);

  const [orderShipment, setOrderShipment] = useState<OrderShipmentModel>({
    delivery: false,
    preOrder: false,
    pickUp: false,
  });
  const [productBadge, setProductBadge] = useState<ProductBadgeModel>({
    newProduct: false,
    recommendProduct: false,
  });

  const description = useRef<HTMLInputElement>(null!);
  const [linkVideo, setLinkVideo] = useState<string>("");
  const packType = useRef<HTMLInputElement>(null!);
  const uomType = useRef<HTMLInputElement>(null!);
  const saleAmount = useRef<HTMLInputElement>(null!);
  const transactionFee = useRef<HTMLInputElement>(null!);
  const deliveryDate = useRef<HTMLInputElement>(null!);
  const [barcode, setBarcode] = useState<string[]>([]);
  const priceRef = useRef<HTMLInputElement>(null!);
  const zoneRef = useRef<HTMLInputElement>(null!);
  const [recommend, setRecommend] = useState<boolean>(false);
  const [productNew, setProductNew] = useState<boolean>(false);

  const [brand, setBrand] = useState<string>(null!);
  const [mainGroup, setMainGroup] = useState<string>("");
  const [division, setDivision] = useState<string>("");
  const [category, setCategory] = useState<string>("");
  const [subCategory, setSubCategory] = useState<string>("");

  const onSelectImageMain = (e: any) => {
    const file = e.target.files[0];
    setImageMainFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setImageMainToShow(reader.result);
      }
    };
    reader.readAsDataURL(file);
    setImageMainToShow(file);
  };

  const onSelectImageSecondary = (e: any, getIndex: number) => {
    const file = e.target.files[0];
    let newImageFile = imageSecondaryFile?.map((item: any, index: number) => {
      if (index === getIndex) {
        return file;
      } else {
        return item;
      }
    });
    if (getIndex === imageSecondaryFile?.length) {
      newImageFile = [...newImageFile, file];
    }
    setImageSecondaryFile(newImageFile);

    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        let newImageUrl = imageSecondaryToShow?.map(
          (item: any, index: number) => {
            if (index === getIndex) {
              return reader.result;
            } else {
              return item;
            }
          }
        );
        if (getIndex === imageSecondaryToShow?.length) {
          newImageUrl = [...newImageUrl, reader.result];
        }
        setImageSecondaryToShow(newImageUrl);
      }
    };
    reader.readAsDataURL(file);
    newImageFile = newImageFile?.map((item: any, index: number) => {
      if (index === getIndex) {
        return file;
      } else {
        return item;
      }
    });
    setImageSecondaryFile(newImageFile);
  };

  const onRemoveSecondaryImage = (getIndex: number) => {
    setImageSecondaryToShow(
      imageSecondaryToShow.filter(
        (item: any, index: number) => index !== getIndex
      )
    );
    setImageSecondaryFile(
      imageSecondaryFile.filter(
        (item: any, index: number) => index !== getIndex
      )
    );
  };

  const onAddBarcode = () => {
    if (!barcode[barcode.length - 1]) {
      setErrorMessage("ກະລຸນາເພີ່ມ Barcode ກ່ອນ");
      return;
    }
    setErrorMessage("");
    setBarcode([...barcode, ""]);
  };

  const handleBrandChange = (e: any) => {
    setBrand(e.target.value);
  };

  const handleUpdateData = async () => {
    try {
      setLoadingSubmit(true);
      const input: any = {
        recommend: recommend,
        productNew: productNew,
        zone: zoneRef.current.value,
        saleAmount: parseInt(saleAmount.current.value),
      };
      await axios.patch(`${PRODUCT_UPDATE}?id=${selectedData?.id}`, input);
      await onRefetchData();
      onClose();
      // onClose(res?.data?.data);
    } catch (err: any) {
      console.log("error=", err);
      try {
        setErrorMessage(err.response.data.message);
      } catch (err2) {
        setErrorMessage("Server error please try again later");
      }
    } finally {
      setLoadingSubmit(false);
      setOpenConfirmDialog(false);
    }
  };

  const handleGetProductByItemCode = async () => {
    // try {
    //   setLoadingGetProductByItemCode(true);
    //   const getProductByItemCode: any = await axios.post(
    //     PRODUCT_MASTER_FIND_MANY,
    //     {
    //       filtter: {
    //         itemcode: itemCode.current.value.trim(),
    //       },
    //     }
    //   );
    //   if (getProductByItemCode?.data?.length > 0) {
    //     setDataPackType(
    //       getProductByItemCode?.data.map(
    //         (item: MasterProductModel) => item?.packType
    //       )
    //     );
    //     setSelectedPackType(getProductByItemCode?.data[0]?.packType);
    //     setMasterProductData(getProductByItemCode?.data);
    //     setErrorGetProductByItemCodeMessage("");
    //   } else {
    //     setErrorGetProductByItemCodeMessage(
    //       "Not found product with this item code"
    //     );
    //   }
    // } catch (err: any) {
    //   try {
    //     setErrorGetProductByItemCodeMessage(err.response.data.message);
    //   } catch (err2) {
    //     setErrorGetProductByItemCodeMessage(
    //       "Server error please try again later"
    //     );
    //   }
    // } finally {
    //   setLoadingGetProductByItemCode(false);
    // }
  };

  const handleCreateData = async () => {
    try {
      setLoadingSubmit(true);
      const getMasterProduct: MasterProductModel = masterProductData?.filter(
        (item: MasterProductModel) => item?.packType === selectedPackType
      )[0];
      const input: any = {
        priceId: getMasterProduct?.master_price[0]?.id,
        merchantId: merchant.id,
      };
      if (mainGroup) {
        input.productMainGroupId = mainGroup;
      }
      if (division) {
        input.productDivisionNameId = division;
      }
      if (category) {
        input.productCategoryId = category;
      }
      if (subCategory) {
        input.productSubCategoryId = subCategory;
      }
      if (transactionFee.current.value) {
        input.transactionFee = parseInt(transactionFee.current.value ?? 0);
      }
      console.log("input=", input);
      await axios.post(PRODUCT_CREATE + `?${objectToQueryString(input)}`);
      // await onRefetchData();
      onClose();
      // onClose(res?.data?.data);
    } catch (err: any) {
      try {
        setErrorMessage(err.response.data.message);
      } catch (err2) {
        setErrorMessage("Server error please try again later");
      }
    } finally {
      setLoadingSubmit(false);
      setOpenConfirmDialog(false);
    }
  };

  const handleFormValidate = (): boolean => {
    setErrorMessage("");
    return true;
  };

  const handleConfirmDialog = () => {
    if (selectedData) {
      handleUpdateData();
    }
  };

  const handleSubmit = () => {
    if (handleFormValidate()) {
      setOpenConfirmDialog(true);
    }
  };

  const handleSelectedPackType = (e: any) => {
    setSelectedPackType(e.target.value);
  };

  // useEffect

  const isUpdating: boolean = selectedData && isFormUpdateData;

  useEffect(() => {
    if (selectedPackType && masterProductData?.length > 0) {
      const getData: MasterProductModel = masterProductData?.filter(
        (item: MasterProductModel) => item?.packType === selectedPackType
      )[0];
      packType.current.value = getData?.packType;
      uomType.current.value = getData?.uomType;
      description.current.value = getData?.description;
      packType.current.value = getData?.packType;
      priceRef.current.value = getData?.master_price[0]?.price.toString();
      console.log("getData=", getData);
      // setMainGroup(getData?.masterMainGroupId);
      // setDivision(getData?.masterDivisionNameId);
      // setCategory(getData?.masterProductCategoryId);
      // setSubCategory(getData?.masterProductSubCategoryId);
      // setLinkVideo(selectedData?.linkViedo);
      setLinkVideo(getData?.linkViedo);
      setImageMainToShow(IMAGE_PRODUCTS_ROOT_URL + getData?.mainImage?.url);
      setImageSecondaryToShow(
        getData?.secondImages?.map(
          (item: any) => IMAGE_PRODUCTS_ROOT_URL + item?.url
        )
      );
      setBarcode(getData?.barcodes ?? []);
      setBrand(getData?.brandId);
    }
  }, [selectedPackType, masterProductData, i18n.language]);

  useEffect(() => {
    if (selectedData && !loading) {
      packType.current.value = selectedData?.price?.masterProduct?.packType;
      uomType.current.value = selectedData?.price?.masterProduct?.uomType;
      description.current.value =
        selectedData?.price?.masterProduct?.description;
      packType.current.value = selectedData?.price?.masterProduct?.packType;
  
      // setLinkVideo(selectedData?.linkViedo);
      setLinkVideo(selectedData?.price?.masterProduct?.linkViedo);
      setImageMainToShow(
        IMAGE_PRODUCTS_ROOT_URL +
          selectedData?.price?.masterProduct?.mainImage?.url
      );
      setImageSecondaryToShow(
        selectedData?.price?.masterProduct?.secondImages?.map(
          (item: any) => IMAGE_PRODUCTS_ROOT_URL + item?.url
        )
      );

      saleAmount.current.value = selectedData?.saleAmount.toString();
      transactionFee.current.value = selectedData?.transactionFee.toString();
      // deliveryDate.current.value = selectedData?.diliveryDate;
      setBarcode(selectedData?.price?.masterProduct?.barcodes ?? []);
      setMainGroup(selectedData?.productMainGroupId);
      setDivision(selectedData?.productDivisionNameId);
      setCategory(selectedData?.productCategoryId);
      setSubCategory(selectedData?.productSubCategoryId);
      setBrand(selectedData?.price?.masterProduct?.brandId);
      zoneRef.current.value = selectedData?.zone;
      setProductNew(selectedData?.productNew);
      setRecommend(selectedData?.recommend);
    }
  }, [selectedData, i18n, loading]);

  return {
    imageMainFile,
    imageMainToShow,
    onSelectImageMain,
    imageSecondaryToShow,
    onSelectImageSecondary,
    onRemoveSecondaryImage,
    description,
    linkVideo,
    orderShipment,
    onOrderShipmentChange: (newValue: OrderShipmentModel) =>
      setOrderShipment(newValue),
    productBadge,
    onProductBadgeChange: (newValue: ProductBadgeModel) =>
      setProductBadge(newValue),
    barcode,
    onBarcodeChange: (newValue: string[]) => setBarcode(newValue),
    onAddBarcode,
    errorMessage,
    handleChangeVideLink: (newValue: string) => setLinkVideo(newValue),
    packType,
    uomType,
    mainGroup,
    division,
    category,
    subCategory,
    handleMasterMainGroupChange: (e: any) => {
      console.log(e.target.value);
      setMainGroup(e.target.value);
      setDivision(null!);
      setCategory(null!);
      setSubCategory(null!);
    },
    handleMasterDivisionChange: (e: any) => {
      setDivision(e.target.value);
      setCategory(null!);
      setSubCategory(null!);
    },
    handleMasterCategoryChange: (e: any) => {
      setCategory(e.target.value);
      setSubCategory(null!);
    },
    handleMasterSubCategoryChange: (e: any) => setSubCategory(e.target.value),
    handleBrandChange,
    brand,
    openConfirmDialog,
    loadingSubmit,
    handleSetOpenConfirmDialog: (newValue: boolean) =>
      setOpenConfirmDialog(newValue),
    handleConfirmDialog,
    handleSubmit,
    saleAmount,
    transactionFee,
    deliveryDate,
    loading,
    handleGetProductByItemCode,
    loadingGetProductByItemCode,
    errorGetProductByItemCodeMessage,
    isUpdating,
    masterProductData,
    selectedPackType,
    handleSelectedPackType,
    dataPackType,
    priceRef,
    zoneRef,
    recommend,
    setRecommend,
    productNew,
    setProductNew,
  };
};
export default useProductMerchantFormController;
